import { Key, ReactNode, useMemo } from 'react'

import { Dropdown, MenuProps, Space } from 'antd'
import { ItemType, MenuDividerType, MenuItemType } from 'antd/es/menu/interface'
import { isNil } from 'lodash'

import { NullIcon } from '@eastcoal/icon/NullIcon'

import { ProDropdownProps } from './interface'

const isDividerItem = (item: ItemType): item is MenuDividerType => {
  return !!item && 'type' in item && item.type === 'divider'
}

const isMenuItem = (item: ItemType): item is MenuItemType => {
  return !!item && 'type' in item && item.type === 'item'
}

const transformItems = (
  items: MenuProps['items'],
  selectedKeys?: Key[],
  selectedIcon?: ReactNode
) => {
  if (!selectedKeys?.length || !selectedIcon) {
    return items
  }
  return items?.map(item => {
    if (isNil(item)) {
      return item
    }
    if (isDividerItem(item)) {
      return item
    }
    if (isMenuItem(item)) {
      const { key, icon, label, ...restItem } = item
      const newIcon = selectedKeys.includes(key) ? selectedIcon : <NullIcon />
      return {
        ...restItem,
        key,
        icon: newIcon,
        label: (
          <Space orientation='horizontal' size='small'>
            {icon}
            {label}
          </Space>
        )
      }
    }
    return {
      ...item,
      children: transformItems(item.children, selectedKeys, selectedIcon)
    }
  })
}

/**
 * 1. 支持设置选中项的图标
 */
export const ProDropdown = ({
  menu = {},
  selectedIcon,
  ...restProps
}: ProDropdownProps) => {
  const { items, selectedKeys, ...restMenu } = menu
  const newItems = useMemo(
    () => transformItems(items, selectedKeys, selectedIcon),
    [selectedIcon, items, selectedKeys]
  )
  return (
    <Dropdown
      menu={{ items: newItems, selectedKeys, ...restMenu }}
      {...restProps}
    />
  )
}
